enum widgetType {
	LIST = 'ListWidget',
	DATE = 'WidgetDate',
	IMAGE = 'WidgetImage',
	SPACER = 'WidgetSpacer',
	STACK = 'WidgetStack',
	TEXT = 'WidgetText',
}

enum Ornt {
	X = 'width',
	Y = 'height',
}

interface Widget {
	id: number;
	type: widgetType;
	attrs: object;
	size: {
		[Ornt.X]: number;
		[Ornt.Y]: number;
	};
}

interface ListWidget extends Widget {
	type: widgetType.LIST;
	bgImageDate: string;
	attrs: {
		backgroundColor: string;
		backgroundGradient: {
			colors: string;
			locations: string;
			angle: number;
		};
		backgroundImage: string;
		refreshAfterDate: string;
		spacing: number;
		url: string;
		padding: {
			top: number;
			left: number;
			bottom: number;
			right: number;
		};
	};
	showNodes: Array<Widget>;
	realNodes: Array<Widget>;
}

// style：applyTimeStyle、applyTimerStyle、applyRelativeStyle、applyOffsetStyle、applyDateStyle
// alignText：rightAlignText、leftAlignText、centerAlignText
interface WidgetDate extends Widget {
	type: widgetType.DATE;
	text: string;
	attrs: {
		date: string;
		font: {
			size: number;
			type: string;
		};
		lineLimit: number;
		minimumScaleFactor: number;
		shadowColor: string;
		shadowOffset: {
			x: number;
			y: number;
		};
		shadowRadius: number;
		textColor: string;
		textOpacity: number;
		url: string;
		style: string;
		alignText: string;
	};
}

interface WidgetText extends Widget {
	type: widgetType.TEXT;
	attrs: {
		text: string;
		font: {
			size: number;
			type: string;
		};
		lineLimit: number;
		minimumScaleFactor: number;
		shadowColor: string;
		shadowOffset: {
			x: number;
			y: number;
		};
		shadowRadius: number;
		textColor: string;
		textOpacity: number;
		url: string;
		alignText: string;
	};
}

// contentMode：applyFillingContentMode、applyFittingContentMode
// alignImage：centerAlignImage、leftAlignImage、rightAlignImage
interface WidgetImage extends Widget {
	type: widgetType.IMAGE;
	attrs: {
		image: string;
		borderColor: string;
		borderWidth: number;
		containerRelativeShape: boolean;
		imageOpacity: number;
		imageSize: {
			[Ornt.X]: number;
			[Ornt.Y]: number;
		};
		cornerRadius: number;
		resizable: boolean;
		tint: {
			color: string;
			opacity: number;
		};
		url: string;
		contentMode: string;
		alignImage: string;
	};
	rawImageDate: string;
	rawImageSize: {
		[Ornt.X]: number;
		[Ornt.Y]: number;
	};
}

interface WidgetSpacer extends Widget {
	type: widgetType.SPACER;
	attrs: {
		length: number;
	};
}

// layout：layoutVertically、layoutHorizontally
// alignContent：bottomAlignContent、topAlignContent、centerAlignContent
interface WidgetStack extends Widget {
	type: widgetType.STACK;
	bgImageDate: string;
	attrs: {
		size: {
			[Ornt.X]: number;
			[Ornt.Y]: number;
		};
		backgroundColor: string;
		backgroundGradient: {
			colors: string;
			locations: string;
			angle: number;
		};
		backgroundImage: string;
		borderColor: string;
		borderWidth: number;
		cornerRadius: number;
		spacing: number;
		url: string;
		padding: {
			top: number;
			left: number;
			bottom: number;
			right: number;
		};
		layout: Ornt;
		alignContent: string;
	};
	showNodes: Array<Widget>;
	realNodes: Array<Widget>;
}

enum dataKey {
	STATE = 'state',
	TYPEOFADDEDWIDGET = 'typeOfAddedWidget',
}

interface State {
	rootWidget: Widget;
	curWidget: Widget;
}

export {
	Widget,
	ListWidget,
	WidgetDate,
	WidgetStack,
	WidgetImage,
	WidgetSpacer,
	WidgetText,
	widgetType,
	dataKey,
	State,
	Ornt,
};
